import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentCompanyIdSelector } from 'domain/documents';
import { toggleEventPanelAction } from 'domain/events';
import { matchRoute } from 'domain/router/utils';

import IconButton from '@mui/material/IconButton';
import Tooltip from 'components/mui/Tooltip';

import HistoryIcon from '@mui/icons-material/History';

import elements from 'components/elements';

const mapStateToProps = (state) => ({
  currentCompanyID: currentCompanyIdSelector(state),
});

const EventsHistoryIconButton = () => {
  const dispatch = useDispatch();
  const { currentCompanyID } = useSelector(mapStateToProps);
  const isCompanyWorkspace = matchRoute.isCompanyWorkspace();
  const isDocument = matchRoute.isDocument();
  const isVisibleIcon = currentCompanyID && (isCompanyWorkspace || isDocument);

  const onClick = () => {
    dispatch(toggleEventPanelAction());
  };

  return (
    isVisibleIcon && (
      <Tooltip t={{ id: 'header.menu.history', defaultMessage: 'History' }}>
        <IconButton color="primary" onClick={onClick} data-element={elements.history.openHistoryButton}>
          <HistoryIcon />
        </IconButton>
      </Tooltip>
    )
  );
};

export default EventsHistoryIconButton;
